module.exports = __webpack_public_path__ + "static/img/ic_no_image.ffda805.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_no_image.png
// module id = 43
// module chunks = 1